import { actions, assign, raise } from "xstate"
import { match } from "ts-pattern"
import { deepEqual } from "fast-equals"
import { ECommerceEvent } from "../e-commerce-machine"
import { ECommerceContext, VsCodeState } from "../e-commerce-machine-context"

type Context = ECommerceContext
type Events = ECommerceEvent

export const vsCodeActions = {
    setVsCode: actions.pure<Context, Events>((ctx, ev) => {
        const newVsCode = match<Events, VsCodeState>(ev)
            .with({ type: "VS_CODE_VALID" }, ({ response }) => ({
                type: "valid",
                value: response.vsCode,
            }))
            .with({ type: "VS_CODE_NOT_VALID" }, () => ({ type: "invalid" }))
            .with({ type: "CHANGE_VS_MEMBER" }, ({ maybeVsMember }) => {
                if (ctx.vsCode.type == "none") return { type: "none", maybeVsMember }
                return ctx.vsCode
            })
            .with({ type: "RESET_VS_CODE" }, () => ({ type: "none", maybeVsMember: false }))
            .otherwise(() => ctx.vsCode)

        if (!deepEqual(ctx.vsCode, newVsCode))
            return [
                assign<Context, Events>(() => ({
                    vsCode: newVsCode,
                })),
                raise({ type: "VS_CODE_CHANGED", vsCode: newVsCode }),
            ]

        return undefined
    }),
}
